import { CommonLayout } from 'layouts';
import ForgotPassword from 'pages/ForgotPassword';
import Login from 'pages/Login';
import Profile from 'pages/Profile';

import ResendEmail from 'pages/ResendEmail';
import ResetPassword from 'pages/ResetPassword';
import VerifyAccount from 'pages/VerifyAccount';
import { Navigate } from 'react-router-dom';
import { ComplexRoute } from './components/Routes/Routes';
import Campaigns from 'pages/Campaigns';
import Campaign from 'pages/Campaign';
import Settings from 'pages/Settings';
import Lead from 'pages/Lead';

export default [
  {
    path: 'login',
    authorized: false,
    onlyPublic: true, //TODO: add default redirection to '/profile' page
    element: Login,
  },
  {
    path: 'forgot-password',
    authorized: false,
    onlyPublic: true,
    element: ForgotPassword,
  },
  {
    path: 'reset-password',
    authorized: false,
    onlyPublic: true,
    element: ResetPassword,
  },
  {
    path: 'verify',
    authorized: false,
    onlyPublic: false,
    element: VerifyAccount,
  },
  {
    path: 'resend-email',
    authorized: false,
    onlyPublic: false,
    element: ResendEmail,
  },
  {
    element: <CommonLayout />,
    routes: [
      {
        path: 'profile',
        element: Profile,
        authorized: true,
      },
      {
        path: 'campaigns',
        element: Campaigns,
        authorized: true,
      },
      {
        path: 'campaigns/:id',
        element: Campaign,
        authorized: true,
      },
      { path: 'lead/:id', element: Lead, authorized: true },
      {
        path: 'settings',
        element: Settings,
        authorized: true,
      },

      {
        index: true,
        element: <Navigate to="campaigns" replace />,
      },
      {
        path: '*',
        element: () => `not found`,
      },
    ],
  },
] as Array<ComplexRoute>;
